import React, { useState } from "react";
import aside from "../Images/Login-img.png";
import "./CSS/ForgotPassword.css";
import CustomButton from "../components/CustomButtonForgot";
import OtpInput from "react-otp-input";
import "./CSS/ForgotPassword.css";
import { useNavigate } from "react-router-dom";
import { READ_ONE_EVENT, VERIFY_OTP } from "../Api/apiConstant";
import { useGetAPIWithoutTokenQuery, usePostAPIMutation } from "../Api/api";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useThemeColors } from "../Context/Theme";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv, secretEncryptionKey } from "../ServiceModule/Service";

function VerifyOTP() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const eventId = sessionStorage.getItem("event_id");
  const location = useLocation();

  const [post, { isSuccess }] = usePostAPIMutation();

  const handleVerifyOtp = async () => {
    if (otp.length === 4) {
      try {
        let payloadData = {
          user_email: location?.state?.email.toLowerCase(),
          otp: otp
        }
        if (isProdEnv == "true") {
          const encryptedPayload = encryptJSON(payloadData, secretEncryptionKey);
          payloadData = {
            element: encryptedPayload,
          }
        }
        else {
          payloadData = payloadData
        }
        const { data } = await post({
          url: VERIFY_OTP,
          formData: payloadData,
        });
        toast.success(data.message);
        navigate(`/events/${eventName}/UpdatePassword`, {
          state: { email: location?.state?.email },
        });
      } catch (error) {

        toast.error("Please enter a vaild OTP");
        setOtp("");
      }
    } else {
      toast.error("Please enter a 4-digit OTP");
      setOtp("");
    }
  };

  const { data, isError } = useGetAPIWithoutTokenQuery(
    `${READ_ONE_EVENT}${eventId}`
  );

  const Theme = useThemeColors();

  const navigateToLogin = () => {
    navigate(`/events/${eventName}/login`);
  };


  return (
    <React.Fragment>
      <ToastContainer limit={1} autoClose={2000} />
      <section class="overflow-hidden">
        <div class="container-fluid">
          <div class="row vh-100">
            <div class="col-sm-6 px-0 py-0 m-0 d-none d-sm-block position-relative">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100vh",
                }}
              >
                <img
                  src={data?.event_img_path ? data?.event_img_path : aside}
                  alt="Login image"
                  className="w-100 vh-100"
                  style={{
                    objectFit: "cover",
                    objectPosition: "left",
                    margin: "0",
                    overflow: "hidden",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                ></div>
              </div>

              <div class="overlay-content" style={{ width: "100%" }}>
                <img
                  src={Theme.logo}
                  alt="Logo"
                  class="logo"
                  width={218}
                  className="mb-5"
                />
                <p
                  style={{ fontSize: "30px", fontWeight: "700", width: "100%" }}
                  class="heading"
                >
                  Welcome to ORDER THAT
                </p>
                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  You're Tailgate Ready with Order That
                </p>
              </div>
            </div>
            <div class="col-sm-6 text-black">
              <div class="d-flex justify-content-center align-items-center h-custom-2 px-5 ms-xl-4  pt-5 pt-xl-0 mt-xl-n5">
                <form
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleVerifyOtp();
                    }
                  }}
                  style={{
                    width: "50rem",
                    height: "27rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    alignItems: "flex-start",
                    padding: "3em",
                    borderRadius: "16px",
                  }}
                >
                  <div style={{ width: "20vw" }}>
                    <p class="login-text mb-3 pb-3 fw-bold">OTP Verification</p>
                    <span className="welcome-text" style={{ color: "#828282" }}>
                      Enter the verification Code we sent on your Email
                    </span>
                  </div>
                  <div>
                    <div data-mdb-input-init class="form-outline mt-3">
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={4}
                        renderInput={(props) => (
                          <input {...props} className="otp-input" />
                        )}
                        containerStyle={{
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: "2em",
                          paddingRight: "2em",
                        }}
                        inputStyle={{
                          width: "6vh",
                          height: "6vh",
                          border: "2px solid #DDDDDD",
                          borderRadius: "0.6em",
                        }}
                       
                        focusStyle={{ border: "2px solid red" }}
                      />
                    </div>
                    <div class="" style={{ width: "25vw" }}>
                      <CustomButton
                        text="Verify OTP"
                        size="lg"
                        block={true}
                        onClick={handleVerifyOtp}
                        className="mt-2"
                        btnStyle={{}}
                        width={"25vw"}
                      />
                    </div>

                    <p
                      className="welcome-text fs-6 mt-3"
                      style={{
                        color: "#828282",
                        width: "80%",
                        textAlign: "left",
                      }}
                    >
                      Remember your password?{" "}
                      <span
                        className="fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={navigateToLogin}
                      >
                        Login
                      </span>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default VerifyOTP;
